import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {MaterialReactTable} from 'material-react-table';
import PropTypes from 'prop-types';

import Swal from 'sweetalert2';
import {

  MenuItem,

} from '@mui/material';

import {  Apitoken, Authtoken } from '../Global';
// import $ from "jquery";
const QualityStockFollowUpViewByLocationDate = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);
  const [permission, setPermission] = useState({});
      let season_id = localStorage.getItem("season_id");

  useEffect(() => {
        setPermission(FindModuleById(455)); 
console.log(permission);

    axios
      .get(`/stock-follow-ups/listing-groupby-location-date-detail/${id+'_'+season_id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.stocks_groupby);
        //setConsumble(response.data.data.consumable_detail);
       

      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

 
  


  // const columns =
  // [

  //   {
  //     accessorKey: 'title',
  //     header: 'Location',
  //   },
  //   {
  //     accessorKey: 'date',
  //     header: 'Date',
  //   },
  //   {
  //     accessorKey: 'operation',
  //     header: 'Operation',
  //    },
  //   {
  //     header: 'Consumable',
  //     accessorFn: (row) => `${(row.consumable_product)?row.consumable_product.consumable_name:""} `,
  //   },
    
  //   {
  //     accessorKey: 'quantity',
  //     header: 'Quantity',
  //   },
  //   {
  //     header: 'Unit Price',
  //     accessorFn: (row) => row.unit_price+`${(row.currency_detail)?row.currency_detail.symbol:""} `,
  //   },

  //   {
  //     header: 'Total Amount',
  //     accessorFn: (row) => row.total_amount+`${(row.currency_detail)?row.currency_detail.symbol:""} `,
  //   },
 
  //   {
  //     //  accessorKey: 'user_status.title', //normal accessorKey
  //       header: 'Delivery Note',
  //       Cell: ({ cell, row }) => {
  //           if(row.original.delivery_note != null){
  //             return(
  //               <a
  //                 className="btn btn-primary"
  //                 href={viewFile(row.original.delivery_note) }
  //                 target="_blank"
  //                 download
  //               >
  //                 Download
  //               </a>
  //             ) 
  //           }
  //       }},
  //   {
  //     accessorKey: 'created_at',
  //     header: 'Created',
  //   },

  //  ];
  // 🔹 Create a separate Cell component for Delivery Note
const DeliveryNoteCell = ({ row }) => {
  if (!row.original?.delivery_note) return null;

  return (
    <a
      className="btn btn-primary"
      href={viewFile(row.original.delivery_note)}
      target="_blank"
      rel="noopener noreferrer"
      download
    >
      Download
    </a>
  );
};

// ✅ Add PropTypes validation
DeliveryNoteCell.propTypes = {
  row: PropTypes.shape({
    original: PropTypes.shape({
      delivery_note: PropTypes.string, // Ensure delivery_note is a string
    }),
  }).isRequired,
};

const columns = [
  {
    accessorKey: 'title',
    header: 'Location',
  },
  {
    accessorKey: 'date',
    header: 'Date',
  },
  {
    accessorKey: 'operation',
    header: 'Operation',
  },
  {
    header: 'Consumable',
    accessorFn: (row) =>
      row.consumable_product ? row.consumable_product.consumable_name : '',
  },
  {
    accessorKey: 'quantity',
    header: 'Quantity',
  },
  {
    header: 'Unit Price',
    accessorFn: (row) =>
      row.unit_price + (row.currency_detail ? row.currency_detail.symbol : ''),
  },
  {
    header: 'Total Amount',
    accessorFn: (row) =>
      row.total_amount + (row.currency_detail ? row.currency_detail.symbol : ''),
  },
  {
    header: 'Delivery Note',
    Cell: DeliveryNoteCell, // ✅ Use the separate component
  },
  {
    accessorKey: 'created_at',
    header: 'Created',
  },
];

   const viewFile =(link) =>{
    AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
    AWS.config.update({
    accessKeyId: AWS_ACCESS_KEY_ID,
    secretAccessKey: AWS_SECRET_ACCESS_KEY,
    region: AWS_DEFAULT_REGION,
    signatureVersion: 'v4',
    });
    const s3 = new AWS.S3();
    var params = {Bucket: AWS_BUCKET, Key: link};
    return  s3.getSignedUrl('getObject', params);
  }

  const editItem = (item)=>{
    window.location.href = "/stock-situations-edit/"+item;
  }


  const deleteItem = (item) => {

    Swal.fire({
      title: 'Do you really want to delete this record?',
      //text: 'This action cannot be undone.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'DELETE'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.get(`/stock-follow-ups/delete/${item}`, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              console.log(response);
              if (response.data.code === 200) {
                Swal.fire(
                  'Deleted!',
                  'Your Record has been deleted.',
                  'success'
                );
                setTimeout(() => {
                  window.location.href = "/stock-situations";
                }, 500);
              }
            })
            .catch((error) => {
              console.log(error);
            }); 
           }
    });
  }

 
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Stock Situation Group By Location and Date </h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/stock-situations">Stock Situations</Link>
                    </li>
                    <li className="breadcrumb-item active">Stock Situations Group By Location and Date</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Stock Situations  Group By Location and Date</h4>
                    <table className="table table-bordered">
                      <tr>
                        {/* <th  className="p-3">Consumble Name</th> */}
                        {/* <td className="p-3">{consumble.consumable_name}</td> */}
                      </tr>
                     
                      {/* <tr>
                        <th className="p-3">Supplier </th>
                        <td className="p-3">
                          {consumble.supplier_detail ? consumble.supplier_detail.name : ""}
                        </td>
                      </tr>
                      <tr>
                        <th className="p-3">Average Level</th>
                        <td className="p-3">{consumble.average_level}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Critical Level</th>
                        <td className="p-3">{consumble.critical_level}</td>
                      </tr>
                      <tr>
                        <th className="p-3">Description</th>
                        <td className="p-3">{consumble.description}</td>
                      </tr> */}

                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                      <div className="table-responsive">
                          <MaterialReactTable columns={columns} data={data} 
                              enableColumnOrdering
                              enablePinning
                              enableRowActions
                              //renderColumnActionsMenuItems 
                              renderRowActionMenuItems={({ row }) => [
                                <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                                  Edit
                                </MenuItem>,
                              //   <MenuItem key="view" onClick={() => viewItem(row.original.id)}>
                              //   View
                              // </MenuItem>,
                              <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                                  Delete
                                </MenuItem>,
                              ]}
                            />
                          </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default QualityStockFollowUpViewByLocationDate;
